module.exports = __webpack_public_path__ + "static/media/unlock-icon.b2026a10.svg";